module.exports = __webpack_public_path__ + "static/BarlowCondensed-Regular-53a17088024b346c54ca3e5bf8cc15ee.ttf";